// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1__a026d63c6e84324c34de","cls2":"Comments-cls2__ccaa9da4fe60fdfa2a0d Comments-cls1__a026d63c6e84324c34de"};